<template>
	<div class="tixian-center">
		<div class="account">
			到帐帐号：17728865438
		</div>

		<div class="action-form">
			<p class="title">提现金额：</p>
			<div class="input-field flex a-center">
				<span>￥</span
				><nut-textinput
					v-model="value"
					type="number"
					placeholder="请输入金额"
					:clearBtn="true"
					:disabled="false"
					:has-border="false"
				/>
			</div>
			<p class="input-desc">可提现金额 823.88 元</p>

			<nut-button block shape="circle" class="tixian-btn" disabled>提现</nut-button>
		</div>

		<div class="rule-desc">
			<p class="name flex a-center">
				<nut-icon
					type="action"
					size="14px"
					style="margin-right: 3px;"
				></nut-icon
				>提现规则：
			</p>
			<ul>
				<li>1.用户每天限提现一次</li>
				<li>2.满1.1元可以提现</li>
				<li>3.单次最高提300元</li>
				<li>4.提现将收取？%的手续费</li>
				<li>5.提现成功后，您的提现资金将于审核成功后2-3个工作日内 到账</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: 'tixian-center',
	data: () => ({
		value: null,
	}),
}
</script>

<style lang="less" scoped>
.tixian-center {
	.account {
		box-sizing: content-box;
		padding: 0 14px;
		height: 50px;
		line-height: 50px;
		background: rgba(255, 255, 255, 1);
		border-radius: 3px;
		border-bottom: 10px solid #f8f8f8;
	}

	.action-form {
		box-sizing: content-box;
		padding: 10px 14px 30px 14px;
		border-bottom: 10px solid #f8f8f8;
		.title {
			margin-bottom: 40px;
		}
		.input-field {
			border-bottom: 1px solid #f0f0f0;
			padding: 10px 0;
			margin-bottom: 10px;
			font-size: 32px;
			color: #333333;
			font-weight: bold;
			line-height: 40px;
		}
		.input-desc {
			font-size: 13px;
			color: #999999;
		}

		// 提现按钮
		.tixian-btn {
			background: linear-gradient(
				42deg,
				rgba(60, 67, 236, 1) 0%,
				rgba(0, 194, 255, 1) 100%
			);
			margin-top: 30px;
			font-weight: bold;
			font-size: 15px;
		}
		.tixian-btn[disabled="disabled"] {
			background:rgba(128,199,255,1) !important;
		}
	}

	/deep/ .nut-textinput input {
		font-size: 32px;
		font-weight: bold;
		color: #333333;
		width: 100%;
	}

	// 提现规则
	.rule-desc {
		padding: 10px 14px;
		color: #666666;
		font-size: 13px;
		.name {
			margin-bottom: 10px;
			color: #333333;
			font-size: 14px;
		}
		li {
			margin: 8px 0;
		}
	}
}
</style>
